<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div [shakeAnimation]="makeShake" class="light-container ticket-edit-container" [formGroup]="editForm">
	<div class="ticket-message-grid">
		<ticket-message [message]="data.messageString"></ticket-message>
	</div>
	<!--  -->
	<!-- CONTENT UNIQUE TO TICKET TYPE -->
	<div class="ticket-edit-container__content multi-edit">
		<div class="ticket-edit-container__header">
			<div class="ticket-edit-container__header-thumbnail--multi-edit">
				<!-- TODO: Handle Assignee color -->
				<multi-edit-thumbnail [typeCounts]="data.typeCounts" [currentType]="data.selectedType">
				</multi-edit-thumbnail>
			</div>
			<div class="multi-edit__masthead">
				<multi-edit-masthead
					[currentType]="data.selectedType"
					[typeCounts]="data.typeCounts"
					[totalTickets]="data.originalList.size"
				>
				</multi-edit-masthead>
			</div>
			<div class="ticket-edit-icons-container">
				<!-- <ticket-icons></ticket-icons> -->
			</div>
			<div class="ticket-edit-container__hamburger-menu">
				<ticket-action-menu [editTicketCombined]="data"></ticket-action-menu>
			</div>
		</div>

		<multi-wrapper
			(onClear)="clearInput('requestedByProjectMemberId')"
			[metadataValue]="data.keyMetadata.get('requestedByProjectMemberId')"
			[disableClear]="true"
			[multipleValuesLabel]="appStrings.GENERAL_MULTIPLE_REQUESTED_BY"
			class="grid-ticket-subcomponent-wrapper ticket-edit-container__constraint-requested-by"
		>
			<ticket-project-member
				class="grid-ticket-subcomponent-wrapper__input"
				formControlName="requestedByProjectMemberId"
				[allowNullSelection]="false"
				(changed)="requestedByChanged($event)"
				[projectMemberList$]="planState.projectMembersApi.data.list$"
				placeholderText="{{ appStrings.CONSTRAINT_REQUESTED_BY.toUpperCase() }}"
			>
			</ticket-project-member>
		</multi-wrapper>

		<multi-wrapper
			(onClear)="clearInput('locationId')"
			[metadataValue]="data.keyMetadata.get('locationId')"
			[disableClear]="true"
			[multipleValuesLabel]="appStrings.GENERAL_MULTIPLE_LOCATIONS"
			class="grid-ticket-subcomponent-wrapper ticket-edit-container__location multi-edit--location dropdown-set-width"
		>
			<ticket-location
				class="grid-ticket-subcomponent-wrapper__input"
				formControlName="locationId"
				automationId="locationId"
				[locationList]="planState.locationsApi.data.list$"
			>
			</ticket-location>
		</multi-wrapper>

		<multi-wrapper
			(onClear)="clearInput('activityName')"
			[metadataValue]="data.keyMetadata.get('activityName')"
			[disableClear]="true"
			class="multi-edit--description grid-ticket-subcomponent-wrapper"
			[multipleValuesLabel]="appStrings.GENERAL_MULTIPLE_DESCRIPTIONS"
		>
			<ticket-description
				class="grid-ticket-subcomponent-wrapper__input ticket-description-fixed-height--multi-edit-constraint"
				[shouldFocus]="data.ticketJustAdded"
				formControlName="activityName"
			>
			</ticket-description>
		</multi-wrapper>

		<multi-wrapper
			(onClear)="clearInput('dateRequested')"
			[metadataValue]="data.keyMetadata.get('dateRequested')"
			[disableClear]="true"
			class="grid-ticket-subcomponent-wrapper ticket-edit-container__constraint-requested-by-date"
			[multipleValuesLabel]="appStrings.GENERAL_MULTIPLE_NEED_BY_DATES"
		>
			<div class="constraint-cal-input grid-ticket-subcomponent-wrapper__input">
				<mat-form-field
					(click)="needByInput.click()"
					class="date-requested"
					*ngIf="editForm.get('dateRequestedAdapter') as dateRequestedControl"
				>
					<mat-label>{{ appStrings.CONSTRAINT_DUE_DATE.toUpperCase() }}</mat-label>
					<input
						matInput
						readonly
						#needByInput
						[matDatepicker]="needbypicker"
						formControlName="dateRequestedAdapter"
						class="custom-field-list-input"
						automationId="constraintNeedByDatePicker"
						(click)="needbypicker.open()"
					/>
					<mat-error *ngIf="editForm.get('dateRequestedAdapter').errors">{{
						appStrings.ENTER_VALID_DATE_ERR
					}}</mat-error>
					<mat-datepicker-toggle
						automationId="needbypicker"
						matSuffix
						[for]="needbypicker"
					></mat-datepicker-toggle>
					<mat-datepicker touchUi #needbypicker></mat-datepicker>
				</mat-form-field>
			</div>
		</multi-wrapper>

		<multi-wrapper
			(onClear)="clearInput('liveAssignedProjectMemberId')"
			[metadataValue]="data.keyMetadata.get('liveAssignedProjectMemberId')"
			[disableClear]="true"
			[multipleValuesLabel]="appStrings.GENERAL_MULTIPLE_ASSIGNED_TO"
			class="grid-ticket-subcomponent-wrapper ticket-edit-container__constraint--assigned-to dropdown-set-width"
		>
			<ticket-project-member
				class="grid-ticket-subcomponent-wrapper__input"
				formControlName="liveAssignedProjectMemberId"
				[allowNullSelection]="false"
				[projectMemberList$]="planState.projectMembersApi.data.list$"
				placeholderText="{{ appStrings.CONSTRAINT_ASSIGNED_TO.toUpperCase() }}"
			>
			</ticket-project-member>
		</multi-wrapper>
		<multi-wrapper
			*ngIf="isAdmin$ | async"
			(onClear)="clearInput('externalScheduleId')"
			[metadataValue]="data.keyMetadata.get('externalScheduleId')"
			class="multi-edit--esid grid-ticket-subcomponent-wrapper"
			[multipleValuesLabel]="appStrings.TICKET_EDIT_MULTIPLE_EXTERNAL_SCHEDULE_ID"
		>
			<ticket-ext-sched-id
				class="grid-ticket-subcomponent-wrapper__input"
				formControlName="externalScheduleId"
			>
			</ticket-ext-sched-id>
		</multi-wrapper>
		<multi-wrapper
			*ngIf="(isAdmin$ | async) && (isWbsCodeEnabled$ | async)"
			(onClear)="clearInput('wbsCode')"
			[metadataValue]="data.keyMetadata.get('wbsCode')"
			class="multi-edit--wbs-code grid-ticket-subcomponent-wrapper"
			[multipleValuesLabel]="appStrings.TICKET_EDIT_MULTIPLE_WBS_CODE_LABEL"
		>
			<ticket-wbs-code
				class="grid-ticket-subcomponent-wrapper__input"
				formControlName="wbsCode"
			></ticket-wbs-code>
		</multi-wrapper>
	</div>
	<ticket-footer
		[showMoreDetailsButton]="false"
		[showActualizedToggle]="false"
		[actualPhase]="data.data.actualPhase"
		[isReadOnly]="(planAccess$ | async) === PlanAccessLevel.archived"
		[formDirty]="editForm.dirty"
		[formValid]="isFormValid"
		[isPlanRegion]="data.ticketsInPlanRegion"
		(onActualChange)="updateActualPhase($event)"
		(canceled)="ticketEditService.closeEdit()"
		(saved)="save()"
	>
	</ticket-footer>
</div>
